import { useEffect, useState } from 'react';
import { useApp, useCompanies, useRest, useLocale } from '../hooks/';
import { ResourcesUsage } from '../types';
import Insights from './Home/Insights';
import Template from '../components/Template';

const Home = () => {
    const [loading, setLoading] = useState(true);
    const [selectedWabaId, setSelectedWabaId] = useState('');

    const [usageMonth, setUsageMonth] = useState<ResourcesUsage>({
        messages_count: { received: 0, sent: 0 },
        messages_templates_count: 0,
        menu_options_count: 0,
        addtional_menu_options: 0,
    });

    const { consume } = useRest();
    const { company, wabaIdSelected } = useApp();
    const [companies] = useCompanies();

    const labels = useLocale({
        allConversations: 'All conversations',
        date: 'Date',
        company: 'Company',
        approximateCharges: 'Approximate charges',
        freePeriodConversations: 'Free period conversations',
        thisMonthsInsights: "This month's insights",
        insights: 'Insights',
        plan: 'Plan',
        current: 'Current',
        companyInitiatedConversations: 'Company-initiated conversations',
        userInitiatedConversations: 'User-initiated conversations',
        menuOptions: 'Menu options',
        messagesTemplatesLimit: 'Messages templates',
        totalUsedMonth: '@USED of @TOTAL used (Month)',
        totalUsed: '@USED of @TOTAL used',
        home: 'Home',
    });

    useEffect(() => {
        (async () => {
            if (selectedWabaId) {
                setLoading(true);

                const usage = await consume<ResourcesUsage>('get', `business/insights/usage/${selectedWabaId}`);

                setLoading(false);
                setUsageMonth(usage);
            }
        })();
    }, [selectedWabaId]);

    useEffect(() => {
        const currentCompnany = companies.find(comp => comp.id == company);
        if (currentCompnany?.company_business_messaging_waba_id) {
            setSelectedWabaId(currentCompnany?.company_business_messaging_waba_id);
        }
    }, [company]);

    const getCompanyPlan = () => {
        const _company = getCompany();
        return _company?.plan;
    };

    const getCompany = () => {
        const _company = companies.find(comp => comp.id == company);
        return _company;
    };

    return (
        <Template header={labels.insights}>
            <Insights
                loading={loading}
                plan={getCompanyPlan()}
                company={getCompany()}
                usageMonth={usageMonth}
                selectedWabaId={wabaIdSelected}
            />
        </Template>
    );
};

export default Home;
